// Config
import makeGiftOptionsReducer from './giftOptionsHigherOrderReducer';
import { APPLY_GIFT_CARD } from '@constants/actionConstants';

export const INITIAL_STATE = {
  isLoading: false,
  formSubmitFailed: false,
  errorMessage: undefined,
};

export default makeGiftOptionsReducer({
  INITIAL_STATE,
  ACTION_NAME: APPLY_GIFT_CARD,
});
